module.exports = __webpack_public_path__ + "img/PA.c4db79b4.png";